"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _connectToWebChat = _interopRequireDefault(require("../connectToWebChat"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var _default = (0, _connectToWebChat.default)(function (_ref) {
  var styleSet = _ref.styleSet;
  return {
    styleSet: styleSet
  };
})(function (_ref2) {
  var autoPlay = _ref2.autoPlay,
      loop = _ref2.loop,
      poster = _ref2.poster,
      src = _ref2.src,
      styleSet = _ref2.styleSet;
  return _react.default.createElement("audio", {
    autoPlay: autoPlay,
    className: styleSet.audioContent,
    controls: true,
    loop: loop,
    poster: poster,
    src: src
  });
});

exports.default = _default;